// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { showAppModal } from "~/redux/actions/app";

// nextjs
import Link from "next/link";

// antd
import { Card, Button, Empty } from "antd";

const CityItemCard = (props) => {
  const { cities, token } = props;

  const handleJoinWechatGroup = () => {
    if (token) {
      props.showAppModal("JoinCityModal");
    } else {
      props.showAppModal("PhoneSigninModal");
    }
  };

  return (
    <Card className="city-list-box">
      {cities ? (
        cities.map((city) => (
          <div
            key={city.id}
            className="city-list-item"
            style={{ backgroundImage: `url(${city.image_url})` }}>
            <div className="city-item-wrapper">
              <div className="city-item-box">
                <div className="city-item-number">{city.job_count}</div>
                <div className="city-item-unit">个</div>
                <div className="city-item-split"></div>
                <div className="city-item-job">
                  <div className="city-item-name">{city.name}</div>
                  <div>工作机会</div>
                </div>
              </div>
            </div>
            <div className="city-item-btn">
              <Link legacyBehavior href={`/categories/5/tags/0-0-0-${city.id}`}>
                <a>
                  <Button type="link" icon={"eye"}>
                    查看工作机会
                  </Button>
                </a>
              </Link>
              <Button
                type="link"
                icon={"usergroup-add"}
                onClick={handleJoinWechatGroup}>
                加入该城市分舵
              </Button>
            </div>
            <div className="city-item-popup">
              <a
                href={`/categories/5/tags/0-0-0-${city.id}`}
                className="ant-btn city-item-button">
                查看工作机会
              </a>
              <Button
                type="link"
                onClick={handleJoinWechatGroup}
                className="city-item-text">
                加入该城市分舵
              </Button>
            </div>
          </div>
        ))
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </Card>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CityItemCard);
